'use client';

import { TrendingUp, Menu, X } from 'lucide-react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useState } from 'react';
import { Button } from '@/components/ui/button';

// Landing page navigation for non-authenticated users
export function NosleadNavigation() {
	const pathname = usePathname();
	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

	return (
		<nav className="bg-white border-b border-gray-200 sticky top-0 z-50">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<div className="flex justify-between items-center h-16">
					{/* Logo */}
					<Link href="/" className="flex items-center space-x-3">
						<div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-500 rounded-xl flex items-center justify-center shadow-md">
							<span className="text-white font-bold text-xl tracking-wider">NOS</span>
						</div>
						<span className="font-semibold text-2xl text-gray-800">Lead</span>
					</Link>

					{/* Public Navigation Links */}
					<div className="flex items-center space-x-6">
						{/* Navigation Tabs */}
						<nav className="hidden md:flex items-center space-x-8">
							<Button
								variant="outline"
								className="border-gray-300 text-gray-700 hover:bg-gray-100 hover:border-gray-400 px-6 py-2.5 rounded-lg font-semibold"
								asChild
							>
								<Link href="/login">Login</Link>
							</Button>
							<Button
								className="bg-gradient-to-r from-blue-500 to-purple-500 text-white px-6 py-2.5 rounded-lg font-semibold hover:from-blue-600 hover:to-purple-600 transition-all duration-200"
								asChild
							>
								<Link href="/signup">Get Started</Link>
							</Button>
						</nav>

						{/* Mobile menu button */}
						<div className="md:hidden">
							<Button
								variant="outline"
								className="border-gray-300 text-gray-700 hover:bg-gray-100 hover:border-gray-400 px-4 py-2 rounded-lg font-semibold"
								asChild
							>
								<Link href="/login">Login</Link>
							</Button>
						</div>
					</div>
				</div>
			</div>
		</nav>
	);
}
